import { UtilityService } from './index'

class DevelopmentServices {

    //TRIM QR

    async getTrimDevelopmentQR(val) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getTrimNumber', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({ trimRefNumber: val })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //TRIM OPTIONS

    async getTrimDevelopmentOptions() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getAllSystemtrims', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        }
    }

    //TRIM HSN

    async getTrimDevelopmentHSN(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getTrimHSN', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }

    async getTrimSysUnits() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getTrimUnits', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: null
        });
        return result.json();
    }

    //fabric HSN


    async getDevelopmentFabricHSN(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getHSN', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }



    //TRIM MULTIPLE FILE UPLOAD

    async getTrimDevelopmentMultipleFileUpload(value) {
        var formData = new FormData();
        // formData.append("refImage",value)
        for (const iterator of value) {
            formData.append("referenceImages", iterator)
        }
        let result = await fetch(UtilityService.baseUrl() + 'api/development/uploadReferenceImages', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return result.json();
    }

    //ADD NEW CUSTOMER

    async addNewCustomer(payload) {
        let result = await fetch(UtilityService.baseUrl() + 'api/customer/AddNewCustomer', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                payload
            })
        });
        return result.json();
    }

    async listCAD(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/cadList', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async searchCadList(searchBy, searchVal, page) {
        let result = await fetch(
            UtilityService.baseUrl() + "api/development/searchCADDev",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    AuthToken: localStorage.getItem("authToken")
                },
                body: JSON.stringify({
                    for: searchVal,
                    by: searchBy,
                    page: page
                })
            }
        );
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async prefillDataCadSystem() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getCAD', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async deleteCAD(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/deleteCAD', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }
    async getCAD(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/viewCAD', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }



    async createCAD(cadInfo) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/CAD', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(cadInfo)
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }

    async createReference(cadInfo) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/cadOptions', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(cadInfo)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async removeCADReference(cadId, refId) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/deleteCADoption', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: cadId,
                CadOptionId: refId
            })
        });
        return result.json();
    }


    async listBNumber(page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/bNumber/Bnumbers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async removeBNumber(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/bNumber', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text: await result.json(),
            status: result.status,
        };
    }

    async searchBNumberDev(searchBy, searchVal, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchBNumberDev', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: searchVal,
                by: searchBy,
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getFabricInfo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchFabricNumber', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                fabricNumber: value
            })
        });
        return result.json();
    }

    async getPrefillInfoForBN() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getBN', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }


    async getMagnumStyleNo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/Search', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleNumber: value
            })
        });
        return result.json();
    }


    async getMagnumStyleNoWithReference(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/getStyleInfo', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: value !== '' ? JSON.stringify({
                styleNumber: value
            }) : ''
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getMagnumStyleNoWithReferenceById(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSampleRequestStyleSelect', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: value !== '' ? JSON.stringify({
                styleReferenceId: value
            }) : ''
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async getDevRefNo() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/generateDevRefNumber', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            }
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async createBNum(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/bNumber', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(
                data
            )
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async editBNum(maxData, fabric, styleNo, buyer, department, washType, garmentType, supplier) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/bNumber', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: maxData._id !== undefined ? maxData._id : "",
                fabric: fabric.value,
                dateOfSubmission: maxData.dateOfSubmission,
                magnumStyleId: styleNo.value,
                customer: buyer.value,
                department: department.value,
                fabricComposition: maxData.fabricComposition,
                fabricComposition2: maxData.fabricComposition2,
                fabricComposition3: maxData.fabricComposition3,
                fabricDescription: maxData.fabricDescription,
                count: parseInt(maxData.count),
                construction: maxData.construction,
                GSM: maxData.GSM,
                greigeMill: maxData.greigeMill,
                wetProcessingMill: maxData.wetProcessingMill,
                laundry: washType.value,
                garmentDying: garmentType.value,

                supplier: supplier.value,
                approvalStatusWithDate: maxData.approvalStatusWithDate,
                itemNumber: maxData.itemNumber,
                remarks: maxData.remarks


            })
        });
        return result.json();
    }
    async getBNumber(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/bNumber', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async listSourcing() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/sourcing', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }

    async createSource(data) {
        var formData = new FormData();
        if (data._id !== undefined) {
            formData.append("_id", data._id);
        }
        formData.append("date", data.date);
        formData.append("magnumStyleId", data.magnumStyleId);
        formData.append("MNID", data.MNID);
        formData.append("sourcingFor", data.sourcingFor);
        formData.append("originationOfRequest", data.originationOfRequest);
        formData.append("season", data.season);
        formData.append("category", data.category);
        formData.append("requirement", data.requirement);
        formData.append("color", data.color);
        formData.append("quantity", data.quantity);
        formData.append("composition", data.composition);

        formData.append("measurement", data.measurement);
        formData.append("dateRequiredAtMagnum", data.dateRequiredAtMagnum);
        formData.append("dateReceivedAtMagnum", data.dateReceivedAtMagnum);
        formData.append("additionalInfo", data.additionalInfo);
        data.refImages.forEach((element) => {
            formData.append("referenceImages", element);
        });
        let result = await fetch(UtilityService.baseUrl() + 'api/development/addSourcing', {
            method: "POST",
            headers: {
                'Accept': 'application/json',

                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async editSource(data) {
        var formData = new FormData();
        if (data._id !== undefined) {
            formData.append("_id", data._id);
        }
        formData.append("date", data.date);
        formData.append("magnumStyleId", data.magnumStyleId.value);
        formData.append("MNID", data.MNID);
        formData.append("sourcingFor", data.sourcingFor);
        formData.append("originationOfRequest", data.originationOfRequest);
        formData.append("season", data.season);
        formData.append("category", data.category);
        formData.append("requirecustomerDepartmentment", data.requirement);
        formData.append("color", data.color);
        formData.append("quantity", data.quantity);
        formData.append("composition", data.composition);

        formData.append("measurement", data.measurement);
        formData.append("dateRequiredAtMagnum", data.dateRequiredAtMagnum);
        formData.append("dateReceivedAtMagnum", data.dateReceivedAtMagnum);
        formData.append("additionalInfo", data.additionalInfo);
        data.refImages.forEach((element) => {
            formData.append("refImages", element);
        });
        data.referenceImages.forEach((element) => {
            formData.append("referenceImages", element);
        });
        let result = await fetch(UtilityService.baseUrl() + 'api/development/addSourcing', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return result.json();
    }

    async removeSourcing(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/sourcing', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }


    async getSpecificSource(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/sourcingView', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async completeSource(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/sourcingCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async listFabric(value) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/fabric/Fabrics', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async listSortedFabric(value) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/getDevelopmentFabric', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: value
            })
        });
        return result.json();
    }
    async removeFabric(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/fabric', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text: result.json(),
            status: result.status
        };
    }

    async prefillFabricDetails() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getFabric', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }

    async getBnoDropdown(value){
        let result = await fetch(UtilityService.baseUrl() + 'api/development/bNumber-dropdown',{
            method: "POST",
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: value !== '' ? JSON.stringify({
                baseRefNumber: value
            }) : ''
        });
        return result.json();
    }

    // async getBnoValues(value){
    //     let result = await fetch(UtilityService.baseUrl() + 'api/development/getSingleBNumber',{
    //         method: "POST",
    //         headers:{
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //             'AuthToken': localStorage.getItem("authToken")
    //         },
    //         body: value !== '' ? JSON.stringify({
    //             _id: value
    //         }) : ''
    //     });
    //     return result.json();
    // }

    async getMeetingNoteId(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/searchMeetingNotes', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                by: "MNId",
                for: value
            })
        });
        return result.json();
    }



    async getMeetingNoteIdForFabric(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/searchMeetingNotes', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                by: "MNId",
                for: value
            })
        });
        return result.json();
    }


    async getPrefillInfoForEmbroidery() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/embroideryData', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }


    async getFabricNumber(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchFabricNumber', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                fabricNumber: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async getBNumberForFabric(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchBNumber', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                baseRefNumber: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getCADRefNumber(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchCAD', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                cadNumber: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getCadNumber() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/generateCadNumber', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            }
        })
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createFabric(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/fabric/storeFabric', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async generateFabric(generateNo) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/generateFabric', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                count: generateNo,
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async fabricStatus(status, id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/updateFabricStatus', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                approvedStatus: status,
                fabricId: id
            })
        });
        return result.json();
    }

    async cadStatus(status, id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/updateApprovedStatusCad', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                approvedStatus: status,
                cadId: id
            })
        });
        return result.json();
    }
    async createYarnDyed(data, toggle, _id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/Fabric/YarnDyed', {
            method: "PUT",
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                yarnDyed: data,
                toggle: toggle,
                _id: _id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createPrint(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/Fabric/print', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createSolid(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/Fabric/Solid', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createSupplierForFabric(data, moduleName) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/' + moduleName + '/Supplier', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getSourcingInfo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchSourcing', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                sourcingNumber: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async createEmbroidery(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/Fabric/embroidery', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async getSpecificFabric(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/fabric', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async listProduct() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/products', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }

    async createProduct(data) {

        var formData = new FormData();
        formData.append("MNId", data.MNId);
        for (let i = 0; i < data.refImages.length; i++) {
            formData.append("referenceImages", data.refImages[i])
        }
        if (data._id !== undefined) {
            formData.append("_id", data._id);
        }
        formData.append("date", data.date);
        formData.append("magnumStyleId", data.magnumStyleId);
        formData.append("MNID", data.MNId);
        formData.append("requestGeneratedBy", data.requestGeneratedBy);
        formData.append("productDevelopmentFor", data.productDevelopmentFor);
        formData.append("originationOfRequest", data.originationOfRequest);
        formData.append("category", data.category);
        formData.append("embroideryTab", data.embroideryTab);
        formData.append("dateRequiredAtMagnum", data.dateRequiredAtMagnum);
        formData.append("dateReceivedAtMagnum", data.dateReceivedAtMagnum);
        formData.append("additionalInfo", data.additionalInfo);
        let result = await fetch(UtilityService.baseUrl() + 'api/development/addProduct', {
            method: "POST",
            headers: {
                'Accept': 'application/json',

                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return result.json();
    }

    async completeProduct(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/productCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }

    async removeProduct(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/product', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }

    async createSample(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/sampleDetails', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                awaitingDevSample: data.awaitingDevSample,
                date: data.date,
                awaitingSheet: data.designSheet,
                data: data.data,
                awaitingDevSheet: data.awaitingDevSheet,
                _id: data._id
            })
        });
        return result.json();
    }



    async createTrimForProductDev(data, id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/trim', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trim: data,
                _id: id
            })
        });
        return result.json();
    }

    async getEmployeId(value, role) {
        let result = await fetch(UtilityService.baseUrl() + 'api/employee/searchEmployees', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                userId: value,
                role: role
            })
        });
        return result.json();
    }

    async createPattern(value) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/pattern', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                date: value.date,
                trailRequired: value.trailRequired,
                existingBlockRefNumber: value.existingBlockRefNumber,
                followedBlockRequired: value.blockRequired,
                blockRefNumber: value.blockRefNumber,
                remarks: value.remarks,
                patternMaster: value.patternMaster,
                _id: value._id
            })
        });
        return result.json();
    }


    async completePattern(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/patternComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async createGarment(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/garmentTechnology', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                sampleForm: value.sampleForm,
                garmentTechComments: value.garmentTechComments,
                trailRequired: value.trailRequired,
                mock: value.mock,
                smvAmmendment: value.smvAmmendment,
                markerRequirements: value.markerRequirements,
                _id: value._id
            })
        });
        return result.json();
    }

    async completeGarment(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/garmentTechnologyComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async createSignOff(date, master, product) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/signOff', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: product,
                merchandiser: master.value,
                date: date

            })
        });
        return result.json();
    }


    async completeSignOff(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/signOffCompleted', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async getSpecificTrim(id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/Trim', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async createCutting(info, product) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/cutting', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: product,
                cutting: info

            })
        });
        return result.json();
    }


    async completeCutting(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/cuttingComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }

    async createSewing(info, product) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/sewing', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: product,
                sewing: info

            })
        });
        return result.json();
    }

    async completeSewing(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/sewingCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async getPrefillInfo() {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSR', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }


    async createDispatch(info, product) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/dispatch', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: product,
                dispatch: info

            })
        });
        return result.json();
    }

    async completeDispatch(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/dispatchCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async searchSuppliersById(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/searchSuppliers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                supplierId: id
            })
        });
        return result.json();
    }

    //generateQrCodeForFabric

    async generateQrCode() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/generateQRFabric', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }

    //searchPrintFabricNumber

    async searchFilterForFabricNumber(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getFabricByRange', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem('authToken')
            },
            body:
                JSON.stringify(data)
        });
        return result.json();
    }

    async getTrimNumber(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchTrim', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trimNumber: value
            })
        });
        return result.json();
    }


    async createFabricForProduct(info, product) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/fabric', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: product,
                fabric: info
            })
        });
        return result.json();
    }

    async completeFabric(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/fabricComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async createTrimForProduct(info, product) {
        // alert("test")


        let result = await fetch(UtilityService.baseUrl() + 'api/development/trim', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trim: info,
                _id: product
            })
        });
        return result.json();
    }



    async completeTrim(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/trimComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async createEmbelishment(data, id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/embellishment', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                aariData: data.aariData,
                manualData: data.manualData,
                tasselData: data.tasselData,
            })
        });
        return result.json();
    }


    async listTrim(page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/Trims', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async removeTrim(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/Trim', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trimId: id
            })
        });
        return {
            text: await result.json(),
            status: result.status,
        };
    }


    async getSupplierInfo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/searchSuppliers', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                supplierId: value
            })
        });
        return result.json();
    }


    async createTrimForMarket(trimInfo) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/createTrimDevelopment', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(trimInfo)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createTrimForProduct(trimInfo) {
        var formData = new FormData();
        if (trimInfo._id !== undefined) {
            formData.append("_id", trimInfo._id);
        }
        formData.append("trimDevelopment", trimInfo.trimDevelopment);
        formData.append("supplier", trimInfo.supplier);
        formData.append("trimCategory", trimInfo.trimCategory);
        formData.append("unit", trimInfo.unit);
        formData.append("size", trimInfo.size);
        formData.append("color", trimInfo.color);
        formData.append("quality", trimInfo.quality);
        formData.append("price", trimInfo.price);
        formData.append("contentOfTrim", trimInfo.contentOfTrim);
        for (const iterator of trimInfo.referenceImages) {
            formData.append("refImage", iterator)
        }
        formData.append("customerId", trimInfo.customerId);
        formData.append("magnumStyleId", trimInfo.magnumStyleId);
        formData.append("requirement", trimInfo.requirement);

        formData.append("isSupplierTestReport", trimInfo.isSupplierTestReport);
        formData.append("supplierTestReport", trimInfo.supplierTestReport);
        formData.append("trimSubCategory", trimInfo.trimSubCategory);
        formData.append("perGrossPrice", trimInfo.perGrossPrice);
        formData.append("source", trimInfo.source);
        formData.append("importedOptions", trimInfo.importedOptions);

        let result = await fetch(UtilityService.baseUrl() + 'api/development/createTrimDevelopment', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                // 'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return result.json();
    }


    async createfullPackageSupplier(type, id, value, fullPackage, jobWork, embroideryRequired, embroideryWidth, blankFabric, allowanceForFraming, selvadge, styleId) {

        let result = await fetch(UtilityService.baseUrl() + `api/development/${type}/Supplier`, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                fullPackage: fullPackage,
                jobWork: jobWork,
                fullPackageDatakey: value,
                embroideryRequired: embroideryRequired,
                embroideryWidth: embroideryWidth,
                blankFabric: blankFabric,
                allowanceForFraming: allowanceForFraming,
                selvadge: selvadge,
                styleId: styleId !== undefined ? styleId.value : ""
            })
        });
        return result.json();
    }


    async createJobWorkSupplier(type, id, value, fullPackage, jobWork, embroideryRequired, embroideryWidth, blankFabric, allowanceForFraming, selvadge, jobWorkProcess, styleId) {
        let result = await fetch(UtilityService.baseUrl() + `api/development/${type}/Supplier`, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                fullPackage: fullPackage,
                jobWork: jobWork,
                jobWorkData: value,
                embroideryRequired: embroideryRequired,
                embroideryWidth: embroideryWidth,
                blankFabric: blankFabric,
                allowanceForFraming: allowanceForFraming,
                selvadge: selvadge,
                jobWorkProcess: jobWorkProcess,
                styleId: styleId !== undefined ? styleId.value : ""
            })
        });
        return result.json();
    }

    async getProductInfo(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/productView', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async ListEmbroidery() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getAllEmbroideries', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: 1
            })
        });
        return result.json();
    }


    async deleteEmbroidery(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/embroidery', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async getSpecificEmbroidery(id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/getSpecificEmbroidery', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }

    async uploadNewImage(image) {

        var formData = new FormData();

        const numFiles = image.length;

        for (let i = 0, numFiles = image.length; i < image.length; i++) {

            formData.append("referenceImages", image[i]);
        }

        let result = await fetch(UtilityService.baseUrl() + 'api/development/uploadReferenceImages', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                // 'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return result.json();
    }


    async createEmbroideryValue(fullData) {

        let result = await fetch(UtilityService.baseUrl() + 'api/development/updateEmbroidery', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                cutPanel: fullData.cutPanel,
                allOver: fullData.allOver,
                garmentForm: fullData.garmentForm,
                semiGarmentForm: fullData.semiGarmentForm,
                tassel: fullData.tassle,
                smocking: fullData.smocking,
                sheering: fullData.sheering,
                additionalInfo: fullData.additionalInfo,
                selected: fullData.data,
                employee: fullData.patternMaster.value,
                refImages: fullData.refImages,
                // colorsNumber: parseInt(fullData.colorsNumber),
                // frames: parseInt(fullData.frames),
                // grading: fullData.grading,
                isMachine: fullData.machine,
                machine: fullData.fullPackageLength,
                sampleRequestId: fullData.sampleNo.value,
                styleId: fullData.styleInfo.value,
                embroideryBacking: fullData.embroideryBacking,
                bitAttaching: fullData.bitAttaching,
                backing: {
                    backingType: fullData.backingType,
                    width: fullData.backingWidth,
                    priceMeter: fullData.backingPrice,
                    consumption: fullData.backingConsumption,
                    totalPrice: (fullData.backingConsumption * fullData.backingPrice),
                    color: fullData.backingColor
                }

            })
        });
        return result.json();
    }

    async updateEmbroideryValue(fullData) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/updateEmbroidery', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: fullData._id,
                cutPanel: fullData.cutPanel,
                allOver: fullData.allOver,
                garmentForm: fullData.garmentForm,
                semiGarmentForm: fullData.semiGarmentForm,
                tassel: fullData.tassle,
                smocking: fullData.smocking,
                sheering: fullData.sheering,
                additionalInfo: fullData.additionalInfo,
                selected: fullData.data,
                employee: fullData.patternMaster.value,
                refImages: fullData.refImages,
                colorsNumber: parseInt(fullData.colorsNumber),
                frames: parseInt(fullData.frames),
                grading: fullData.grading,
                data: fullData.fullPackageLength

            })
        });
        return result.json();
    }


    async getEmployeInfo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/searchEmployee', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }

    //generateQR
    async generateQRBNumber() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/generateQRBNumber', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    //Get Fabric Info
    async getBFabricInfo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchFabricNumber', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                fabricNumber: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //Get Fabric PreFillData
    async prefillSpecificFabricDetails(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getFabric', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async searchFabricBy(by, value, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchFabricDev', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: value,
                by: by,
                page: page,
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async searchTrimBy(by, value, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/searchTrimDev', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: value,
                by: by,
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //getFabricbyId
    async getFabricbyId(_id) {
        let result = await fetch(
            UtilityService.baseUrl() + "api/development/getFABOneById ",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    AuthToken: localStorage.getItem("authToken")
                },
                body: JSON.stringify({
                    _id: _id
                })
            }
        );
        return {
            status: result.status,
            text: await result.json()
        };
    }

}
export default new DevelopmentServices();


// WEBPACK FOOTER //
// ./src/services/development.service.js